module.exports = __webpack_public_path__ + "static/media/twitter.08a392f0.svg";